import { createSlice } from '@reduxjs/toolkit';
import API from '../../services/api';
import {SURVEYS_API_URL, USERS_API_URL} from '../../config/service';
import { showError } from '../messages/messagesSlice';

const initialState={
  externalusertasks:[],
}
export const externalUserTasksSlice = createSlice({
  name: 'externalusertasks',
  initialState: {
    externalusertasks: [],
    adminlist: [],
  },
  reducers: {
    setExternalUserTasks: (state, action) => {
        if (action.payload)
        {
            state.externalusertasks = action.payload;
            state.isLoadingExternalUserTasks = false;
        }
    },
    resetExternalUserTasks: state => initialState,
    setAdminList: (state, action) => {
      if(action.payload){
        state.adminlist= action.payload
      }
    },
  },
});

export const { setExternalUserTasks, resetExternalUserTasks, setAdminList } = externalUserTasksSlice.actions;

export const unlistExternalUserTasks = () => dispatch => {dispatch(resetExternalUserTasks())};

export const listExternalUserTasks = (username, cso_identifier) => dispatch => {
    try {
          API.post(`${SURVEYS_API_URL}/v1/surveys/external/allocated/search`, 
          {
            username: username,
            cso_identifier: cso_identifier
          })
          .then((response) => 
          dispatch(setExternalUserTasks(response.data.Items)));
    }
    catch(error) {
        dispatch(showError({ "message": `List tasks failed. ${error.message}` }));
    };
};

export const listExternalUserAdmins = (cso_identifier)=> dispatch =>{
  try{
      API.get(`${USERS_API_URL}/v1/users/adminlist/${cso_identifier}`)
    .then((response)=> dispatch(setAdminList(response.data)))
  }
  catch(error){
    dispatch(showError({ "message": `Fetching admin list failed. ${error.message}` }));
  };
}

export const selectExternalUserTasks = state => state.externalusertasks.externalusertasks;
export const selectExternalUserAdminList = state => state.adminlist.adminlist;
export default externalUserTasksSlice.reducer;
